<template>
  <user-search></user-search>
</template>

<script>
import UserSearch from "./UserSearch.vue";
export default {
  name: "MakerUserSearch",
  components: {
    UserSearch,
  },
};
</script>
